import React from 'react'
import TourOperatorSection from '../../sections/TourOperatorSection'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'

const TourOperators = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Tour Operators" />
            <CommonBreadcrumb items={["Tour Operators"]} />
            <TourOperatorSection />
            <Footer />
        </>
    )
}

export default TourOperators